import { post } from "@/api/common/request";

// POST /anticheat/action/report
// 入参：interview_id、action_type、action_time、client_info
export const reportAnticheatAction = (params) => post("/anticheat/action/report", params);

